import React, { Component } from 'react'
import request from '../../../lib/requester'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import moment from 'moment'
import _ from 'lodash'
import ReactExport from "react-export-excel-hot-fix"
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class ClaimSummaryCHD extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataTable: [],
      baseTable: [],
      loading: false,
      user: JSON.parse(window.localStorage.getItem('is_user')) || {}
    }
  }

  componentDidMount = () => {
    this.getDataSummary()
  }

  getDataSummary = () => {
    let { user } = this.state
    let url = '/api/traces_chd/v1/customer/list-setup'
    let param = {
      branch: user.branch
    }
    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ dataTable: data, baseTable: data, loading: false })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: 'CUSTOMER ID',
          accessor: 'customer_id',
          filterable: true
        },
        {
          Header: 'CUSTOMER NAME',
          accessor: 'customer_name',
          filterable: true,
          width: 300
        },
        {
          Header: 'STATUS',
          accessor: 'status_desc',
          filterable: true,
          Cell: function (row) {
            let classBadge = app.statusCustomer(row.value, 'class');
            let text = app.statusCustomer(row.value, 'text');
            return (
              <span><div className={classBadge}>{text}</div></span>
            )
          }
        },
        {
          Header: 'ACTIVE',
          accessor: 'is_active',
          filterable: true
        },
        {
          Header: 'SOURCE',
          accessor: 'source_flag',
          filterable: true
        },
        {
          Header: 'CHANNEL',
          accessor: 'channel',
          filterable: true
        },
        {
          Header: 'CUSTOMER GROUP',
          accessor: 'customer_group',
          filterable: true
        },
        {
          Header: 'BANK NAME',
          accessor: 'bank_name',
          filterable: true
        },
        {
          Header: 'BANK ACCOUNT NO',
          accessor: 'bank_account_no',
          filterable: true
        },
        {
          Header: 'BANK ACCOUNT OWNER',
          accessor: 'bank_account_owner',
          filterable: true
        },
        {
          Header: 'PKP BADAN',
          accessor: 'pkp_badan',
          filterable: true
        },
        {
          Header: 'NPWP ID',
          accessor: 'npwp',
          filterable: true
        },
        {
          Header: 'NPWP NAME',
          accessor: 'npwp_name',
          filterable: true
        },
        {
          Header: 'NPWP ADDRESS',
          accessor: 'npwp_address',
          filterable: true
        },
        {
          Header: '',
          accessor: 'customer_id',
          Cell: (row) => {
            return (
              <span>
                <button className="btn btn-info btn-sm" onClick={() => { this.goDetail(row) }}><i class="fas fa-eye"></i> View</button>
              </span>
            )
          }
        }
      ],
      rows: this.state.dataTable
    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
      defaultFilterMethod={((filter, row, column) => {
        let columnes = ""
        switch (filter.id) {
          case "start_date":
            columnes = row._original.formatted_start_date
            break;
          case "end_date":
            columnes = row._original.formatted_end_date
            break;
          case "claim_exp_date":
            columnes = row._original.formatted_exp_date
            break;
          case "creation_date":
            columnes = row._original.formatted_submitted_date
            break;
          default:
            columnes = row[filter.id]
        }

        return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
      })}
    />)
  }

  goDetail = (row) => {
    this.props.history.push('/admin/setup/customer/create?id=' + row.value)
  }

  statusCustomer = (status, type) => {
    let output = { text: "", class: "" }
    switch (status) {
      case "approved":
        output.text = "approved";
        output.class = "badge badge-success"
        break;
      case "validated":
        output.text = "validated";
        output.class = "badge badge-primary"
        break;
      case "proposed":
        output.text = "proposed";
        output.class = "badge badge-warning"
        break;
      case "rejected":
        output.text = "rejected";
        output.class = "badge badge-danger"
        break;
      default:
        output.text = "waiting approval"
        output.class = "badge badge-warning"
        break;
    }
    return output[type]
  }

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable
    let filename = 'claim-summary-' + moment(new Date()).format('DDMMYYYYHHmmss')

    return (
      <ExcelFile filename={filename} fileExtension="xls" element={(<button className="btn btn-success"><i className="fas fa-file-excel" />Export to excel</button>)}>
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="Claim Number" value="claim_number" />
          <ExcelColumn label="Traces Number" value="skp_number" />                    <ExcelColumn label="Skp Number" value="skp_number" />
          <ExcelColumn label="Ref No" value="ref_number" />
          <ExcelColumn label="Program Type" value="program_name" />
          <ExcelColumn label="Description" value="description" />
          <ExcelColumn label="Start Date" value="formatted_start_date" />
          <ExcelColumn label="End Date" value="formatted_end_date" />
          <ExcelColumn label="Claim Exp" value="formatted_claim_exp" />
          <ExcelColumn label="Submitted Date" value="creation_date" />
          <ExcelColumn label="Amount" value="total_claim" />
          <ExcelColumn label="Customer" value="customer_name" />
          <ExcelColumn label="Status" value="status" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  badgeType = (status, format) => {
    let output = {
      type: ''
    }
    switch (status) {
      case 'Draft':
        output.type = 'badge badge-info'
        break
      case 'Approved':
        output.type = 'badge badge-success'
        break
      case 'Rejected':
        output.type = 'badge badge-danger'
        break
    }
    return output[format]
  }

  thousandSeparator = (value) => {
    if (value.length === 0) return

    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  goDownload = (row) => {
    return false
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-6 float-left">
                        <div className="row">
                          <div className="col-lg-12">
                            {/* {this.exportToExcel()} */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 float-right">
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">
                        <button type="button" className="btn btn-primary mb-2" onClick={() => { this.props.history.push('/admin/setup/customer/create') }}><i className="fa fa-plus" /> Add New Customer</button>
                        {this.renderTable()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default ClaimSummaryCHD